import {clsx, type ClassValue} from "clsx";
import {twMerge} from "tailwind-merge";

/**
 * Merge multiple class values into a single string using both twMerge and clsx.
 * clsx joins class strings without repetitions on a conditional basis.
 * twMerge goes even farther to enforce rules about which tw classes should be used together and in what order.
 *
 *
 * @see https://github.com/dcastil/tailwind-merge For details on Tailwind Merge.
 * @see https://github.com/lukeed/clsx For details on clsx.
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Standard focus ring styles used across all interactive elements.
 * Provides consistent keyboard navigation visual feedback.
 * outline-none suppresses the default browser focus ring.
 */
export const FOCUS_RING_CLASSES =
	"outline-none focus-visible:ring-[2px] focus-visible:ring-[var(--color-brand-bold-pressed)] focus-visible:ring-offset-1";
